module.exports = __webpack_public_path__ + "static/media/arenaProduct.6ed6ce3e.jpg";